
/* injects from baggage-loader */

'use strict';

import RaiseFundsController from './raise-funds.controller';
import RaiseFundsTemplate from './raise-funds.html';

export default class RaiseFundsComponent {
		constructor() {
				this.templateUrl = RaiseFundsTemplate;
				this.controller = RaiseFundsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = {};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/raise-funds/raise-funds.component.js